import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-659daadc")
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(":")
_popScopeId()

import { computed } from 'vue';

import useNumbers from '@/composables/useNumbers';
import useTokens from '@/composables/useTokens';
import { includesAddress } from '@/lib/utils';
import { PoolToken } from '@/services/pool/types';

import HiddenTokensPills from './HiddenTokensPills.vue';
import StableTokenPill from './StableTokenPill.vue';
import WeightedTokenPill from './WeightedTokenPill.vue';
import { bool } from 'prop-types';

type Props = {
  tokens: PoolToken[];
  boosted:Boolean;
};


export default _defineComponent({
  props: {
    tokens: { type: Array, required: true },
    boosted: { type: null, required: true }
  } as unknown as undefined,
  setup(__props: {
  tokens: PoolToken[];
  boosted:Boolean;
}) {

const props = __props


const { fNum2 } = useNumbers();
const { getToken } = useTokens();

/**
 * COMPUTED
 */
const visibleTokens = computed(() => props.tokens.slice(0, MAX_PILLS));

const hiddenTokens = computed(() => props.tokens.slice(MAX_PILLS));




/**
 * METHODS
 */
function symbolFor(token: PoolToken): string {
  return token.symbol || getToken(token.address)?.symbol || '---';
}

function weightFor(token: PoolToken): string {
  return fNum2(token.weight, {
    style: 'percent',
    maximumFractionDigits: 0,
  });
}
function getTitle(tokens: PoolToken[]): string{
    if(tokens.length==3)
        return 'Tripool';
    else if(isBalanced(tokens))
        return 'Balanced';
    else
        return 'Unbalanced';
}
function isBalanced(tokens: PoolToken[]):boolean{
    var perc = tokens[0].weight;
    var out = true;
    tokens.forEach(token => {
        if(perc != token.weight)
            out = false;
            return;
    });
    return out;
}
function getBgClass(tokens: PoolToken[],boosted:Boolean): string{
    if(boosted!=undefined && boosted)
      return 'bg-red';
    else if(tokens.length==3)
      return 'bg-green';
    else if(isBalanced(tokens))
      return 'bg-grey';
    else
      return 'bg-blue';
}

const MAX_PILLS = 11;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["weight flex", getBgClass(__props.tokens,__props.boosted)])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(getTitle(__props.tokens)), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleTokens), (token, idx) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (idx!=0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_3
            ], 64))
          : _createCommentVNode("", true),
        _createTextVNode(_toDisplayString(token.weight*100), 1)
      ]))
    }), 256))
  ], 2))
}
}

})